import { getMiniHostAppDetail } from '../getMiniHostAppDetail';
import type { HostAppFeature } from '../types/MiniHostAppDetail';

/**
 * Function to check whether some feature is enabled on the native side or not
 * @param flagName Native feature flag name
 * @returns Boolean value depicting if some feature is being enabled on the native side
 */
export function isNativeFeatureEnabled(flagName: HostAppFeature): boolean {
    return !!getMiniHostAppDetail()?.hostAppFeatureFlags?.includes(flagName);
}
